import { LitElement, html, Splide } from '@hh/global.js'

export class FeaturesSlideshow extends LitElement {
  static properties = {
    slider: { state: true },
    slideCount: {type: Number }
  }

  connectedCallback() {
    super.connectedCallback()

    const slider = this.querySelector('[data-splide-slider]')
    if (slider) {
      this.initSlider(slider)
    }
  }

  initSlider(slider) {
    this.slider = new Splide(slider, {
      arrows: true,
      pagination: true,
      autoplay: false,
      useScroll: true,
      fixedWidth: true,
      gap: 24,
      padding: 16,
      snap: true,
      focus: (this.slideCount >= 4) ? 'center' : 0,
      omitEnd: true,
      speed: 800,
      easing: 'linear',
      breakpoints: {
        767: {
          gap: 16,
          focus: 0,
          speed: 400
        },
      },
    })

    if (document.documentElement.clientWidth < 768) {
      this.closeAllSlides()
    }

    this.slider.mount()

    this.slider.root
      .querySelectorAll('[data-expand-button]')
      .forEach((el) =>
        el.addEventListener('click', this.toggleExpandSlide.bind(this))
      )

    this.slider.root
      .querySelectorAll('[data-splide-slide]')
      .forEach((el) =>
        el.addEventListener('click', this.toggleExpandSlide.bind(this))
      )
  }

  closeAllSlides(animate = false) {
    this.querySelectorAll('[data-splide-slide]')?.forEach((slide) => {
      if (!slide.classList.contains('is-expanded')) return
      const heading = slide.querySelector('[data-slide-heading]')
      if (animate) {
        heading.style.minWidth = `${heading.offsetWidth}px`
        slide.classList.add('is-animating')
        clearInterval(this.interval)
        this.interval = setInterval(() => {
          this.slider.refresh()
        }, 15)
      }
      slide.setAttribute('aria-expanded', 'false')
      slide.classList.remove('is-expanded')
      if (animate) {
        setTimeout(() => {
          clearInterval(this.interval)
          heading.style.minWidth = null
          this.slider.refresh()
          slide.classList.remove('is-animating')
        }, 800)
      }
    })
  }

  toggleExpandSlide(event) {
    event.stopPropagation()
    const currentTarget = event.currentTarget

    const slide = currentTarget.closest('[data-splide-slide]')
    const heading = slide.querySelector('[data-slide-heading]')
    heading.style.minWidth = `${heading.offsetWidth}px`
    const isExpanded = slide.classList.contains('is-expanded')

    const newSlideIndex = Number(slide.dataset?.splideSlide || 0)
    const currentSlideIndex = this.slider.index
    const moveSlideOnDesktop = (
      window.innerWidth >= 768 &&
      newSlideIndex !== currentSlideIndex &&
      this.slideCount >= 4
    )

    if (moveSlideOnDesktop) {
      this.slider.go(newSlideIndex)
    }

    setTimeout(() => { //Wait for slide to be focused on desktop
      if (isExpanded) {
        slide.setAttribute('aria-expanded', 'false')
        currentTarget.setAttribute(
          'aria-label',
          currentTarget.dataset.labelReadMore
        )
      } else {
        this.closeAllSlides(true)
        slide.setAttribute('aria-expanded', 'true')
        currentTarget.setAttribute(
          'aria-label',
          currentTarget.dataset.labelReadLess
        )
      }

      slide.classList.toggle('is-expanded')
      slide.classList.add('is-animating')
      clearInterval(this.interval)

      this.interval = setInterval(() => {
        this.slider.refresh()
      }, 15)

      setTimeout(() => {
        clearInterval(this.interval)
        heading.style.minWidth = null
        this.slider.refresh()
        slide.classList.remove('is-animating')

        if (
          newSlideIndex === this.slideCount - 1 &&
          slide.classList.contains('is-expanded') &&
          window.innerWidth >= 768
        ) {
          const maxIndex = this.slideCount - 1
          this.slider.go(maxIndex)
        }
      }, 800)
    }, moveSlideOnDesktop ? 500 : 0)
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('features-slideshow', FeaturesSlideshow)
